import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
// import { disableBodyScrolling } from '@/utils/disableBodyScrolling';

@Component
export class MobileFiltersTrigger extends ThemeComponent {
    @Prop({default: window.pageYOffset}) scrollPosition!: number;
    init() {
        // Give initial value for scrollPosition
        this.scrollPosition = window.pageYOffset;

        // Init click event listeners
        this.initClickEventListener();
        document.addEventListener('closeFilterDrawer', () => {
            this.classChanges();
        });

        // Init navigation breakpoint check
        this.matchMedia();
    }

    initClickEventListener() {
        this.$listen(this, 'click', (evt) => {
            this.classChanges();
            // Trigger class
            this.classList.toggle('navigation-mobile-filters-toggle--active');
        });
    }

    classChanges() {
        // Check mobile menu exists
        const mobileMenu = document.querySelector('.mobile-filters');

        if (!mobileMenu) {
            return;
        }
        // Body class
        document.body.classList.toggle('no-scroll');

        // Mobile menu class
        mobileMenu.classList.toggle('is-active');
    }

    matchMedia() {
        // Remove mobile menu active active if greater than $navigation-breakpoint
        const mmBreakpoint = window.matchMedia(`(max-width: 950px)`);

        // Check breakpoint, remove mobile menu classes if required
        const breakpointChecker = () => {
            if (!mmBreakpoint.matches) {

                // Only run if filters are active
                if (!document.body.classList.contains('no-scroll')) {
                    return;
                }

                // Check mobile menu exists
                const mobileMenu = document.querySelector('.mobile-filters');
                if (!mobileMenu) {
                    return;
                }

                // Body class
                document.body.classList.remove('no-scroll');

                // Mobile menu class
                mobileMenu.classList.remove('is-active');

                // Trigger class
                this.classList.remove('navigation-mobile-filters-toggle--active');
            }
        };

        // Init listener and initial check
        breakpointChecker();
        mmBreakpoint.addListener(breakpointChecker);
    }
}
